/**
 * Shared visual language for agent-generated views — the same palette the ported field/capacity
 * engines use, so a pinned view reads as native to the product rather than a second style.
 */

import { DXC, NPI_GOLD } from "@/features/sku-velocity/field/util";

/** Primary emphasis / `highlight_keys` — the accent red already used for selection state
 *  throughout the field and capacity screens (`math.ts`'s `npiBarGrad`, `CapNote`'s red ink). */
export const HIGHLIGHT_PRIMARY = "#EB1700";
/** Secondary emphasis — the cool Dx accent, reused here as "the other cohort" rather than a new
 *  color, so a two-cohort view never invents a third palette. */
export const HIGHLIGHT_SECONDARY = DXC;
/** Baseline / unhighlighted nodes and bars. */
export const NEUTRAL = "#C7C3BE";
export const NEUTRAL_DARK = "#706D6D";
export { NPI_GOLD };

export const GRID_LINE = "#E2E2E2";
/** Chart ink and "over ceiling" red — the same two tokens `proto.css` names `--ink` / `--red-ink`. */
export const INK = "#141414";
export const RED_INK = "#9E0000";
